import React from "react";
import { Link } from "react-router-dom";

export default function PaceNotes() {
  const blogPosts = [
    {
      title: "How to Train for Your First Marathon",
      slug: "first-marathon-training",
      description: "A beginner's guide to running 26.2 miles without burning out.",
      date: "June 10, 2025",
    },
    {
      title: "Why Cutback Weeks Matter",
      slug: "cutback-weeks-explained",
      description: "Why running less can actually help you run more.",
      date: "June 14, 2025",
    },
  ];

  return (
    <div style={{ maxWidth: "800px", margin: "0 auto", padding: "2rem", color: "white" }}>
      <h1 style={{ fontSize: "2.5rem", marginBottom: "1rem" }}>PaceNotes 📝</h1>
      <p style={{ marginBottom: "2rem", color: "#aaa" }}>
        Tips, strategies, and tools to run smarter — not harder.
      </p>

      {blogPosts.map((post) => (
        <div
          key={post.slug}
          style={{
            marginBottom: "2rem",
            padding: "1rem",
            border: "1px solid #333",
            borderRadius: "12px",
            backgroundColor: "#2a2a2e",
          }}
        >
          <h2 style={{ fontSize: "1.5rem", marginBottom: "0.25rem" }}>{post.title}</h2>
          <p style={{ fontSize: "0.85rem", color: "#888" }}>{post.date}</p>
          <p style={{ margin: "0.5rem 0" }}>{post.description}</p>
          <Link
            to={`/pace-notes/${post.slug}`}
            style={{
              color: "#00b894",
              textDecoration: "underline",
              fontWeight: "500",
            }}
          >
            Read more →
          </Link>
        </div>
      ))}
    </div>
  );
}

